import { render, staticRenderFns } from "./display-field-comment.vue?vue&type=template&id=1f7347a6&scoped=true&"
import script from "./display-field-comment.ts?vue&type=script&lang=ts&"
export * from "./display-field-comment.ts?vue&type=script&lang=ts&"
import style0 from "./display-field-comment.scss?vue&type=style&index=0&id=1f7347a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7347a6",
  null
  
)

export default component.exports